export enum RequestScheduleSelectPeriodTypeEnum {
	MORNING = 'morning',
	AFTERNOON = 'afternoon',
	NIGHT = 'night',
}
